exports = function(val) {
    return val;
};

module.exports = exports;
